type MaybeGetter<T, Args extends any[]> = T | ((...args: Args) => T);

export function callOrReturn<V, Args extends any[]>(value: MaybeGetter<V, Args>, ...args: Args): V {
	return typeof value === 'function' ? (value as (...args: Args) => V)(...args) : value;
}

export function noop() {}

export function isNil(value: unknown): value is undefined | null {
	return value === undefined || value === null;
}
